export default __webpack_public_path__ + "locales/ru/Payments.json?hash=6e09ffd92d0ec762c114f73b071135c1";